var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6637_43484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98382 11.8358H3.91741V6.02668H1.98382V11.8358ZM4.04297 4.23539C4.03739 3.94521 3.93694 3.70525 3.74163 3.51552C3.54632 3.32579 3.28683 3.23092 2.96317 3.23092C2.63951 3.23092 2.37584 3.32579 2.17215 3.51552C1.96847 3.70525 1.86663 3.94521 1.86663 4.23539C1.86663 4.51999 1.96568 4.75854 2.16378 4.95107C2.36189 5.14359 2.61998 5.23985 2.93806 5.23985H2.94643C3.27567 5.23985 3.54074 5.14359 3.74163 4.95107C3.94252 4.75854 4.04297 4.51999 4.04297 4.23539ZM8.93973 11.8358H10.8733V8.50436C10.8733 7.64498 10.6696 6.99487 10.2623 6.55403C9.85491 6.11318 9.31641 5.89275 8.64676 5.89275C7.88783 5.89275 7.30469 6.2192 6.89732 6.87211H6.91406V6.02668H4.98047C4.99721 6.39498 4.99721 8.33137 4.98047 11.8358H6.91406V8.58807C6.91406 8.37601 6.93359 8.21976 6.97266 8.11932C7.05636 7.924 7.18192 7.75799 7.34933 7.62127C7.51674 7.48455 7.72321 7.41619 7.96875 7.41619C8.61607 7.41619 8.93973 7.85425 8.93973 8.73036V11.8358ZM12.8571 3.48204V11.5178C12.8571 12.1818 12.6214 12.7496 12.1498 13.2212C11.6783 13.6927 11.1105 13.9285 10.4464 13.9285H2.41071C1.74665 13.9285 1.17885 13.6927 0.70731 13.2212C0.23577 12.7496 0 12.1818 0 11.5178V3.48204C0 2.81798 0.23577 2.25017 0.70731 1.77864C1.17885 1.30709 1.74665 1.07132 2.41071 1.07132H10.4464C11.1105 1.07132 11.6783 1.30709 12.1498 1.77864C12.6214 2.25017 12.8571 2.81798 12.8571 3.48204Z",
    fill: "#2A85FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6637_43484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.86,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinFill);
export default __webpack_public_path__ + "static/media/linkdin-fill.9028a8490cce572aed9dbf4e0e29327c.svg";
export { ForwardRef as ReactComponent };